export default "__VITE_ASSET__NzXdFe8l__"